import { CustomAxiosHeaders } from '../config/services'
import config from '../config'
import { requests } from '.'

// use serviceName value below as key in `versions` object in `src/config/services.ts` for developer versions
const serviceName = 'ProductServices'
const host = config.productsApiURL
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

interface FetchProductLogs {
  locationId: string

  productId?: string

  limit: number

  offset: number

  success?: string

  methods?: string

  startAt?: string

  endAt?: string
}

interface ListProducts {

  locationId: string

  parentId?: string

  limit: number

  offset?: number

  search?: string
}

const ProductServices = {
  fetchProduct: productId =>
    request().get(`/products/${productId}`),

  createProduct: params =>
    request().post(`/products/`, params),

  deleteProduct: productId =>
    request().delete(`/products/${productId}`),

  listProducts: (params:ListProducts) =>
    request().get(`/products/`, { params }),

  createPrice: params =>
    request().post(`/products/prices`, params),

  updatePrice: (params, id) =>
    request().put(`/products/prices/${id}`, params),

  deletePrice: priceId =>
    request().delete(`/products/prices/${priceId}`),

  updateProduct: (params, id) =>
    request().put(`/products/${id}`, params),

  fetchPrice: priceId =>
    request().get(`/products/prices/${priceId}`),

  fetchProductLogs: (params: FetchProductLogs) =>
    request({ host: config.requestLoggerApiURL }).get(`/request-logger/products`, {
      params: params,
    }),

  findByLogId: requestId =>
    request({ host: config.requestLoggerApiURL }).get(`/request-logger/${requestId}`),

  syncProduct: params =>
    request().post(`/products/sync`, params),

  getProductWithIntegrations: (params) =>
    request().get(`/products/with-integrations`,{params}),

  getStripePrices: (params) =>
    request().get(`/products/prices/stripe`, { params }),

  importStripeProduct: params =>
    request().post(`/products/prices/stripe/import`, params),

  getStripePlans: params =>
    request().get(`/products/stripe-plans`, {params})
}

export default ProductServices
